<template>
  <div id="drop-down" style="align-self: center;">
    <div class="dropdown" ref="dropDownEl">
      <div class="dropdown-trigger">
        <button
          class="button"
          aria-haspopup="true"
          aria-controls="dropdown-menu"
        >
          <span>Three Js</span>
          <span class="icon is-small">
            <i
              class="fas fa-angle-down"
              aria-hidden="true"
            ></i>
          </span>
        </button>
      </div>
      <div
        class="dropdown-menu"
        id="dropdown-menu"
        role="menu"
      >
        <div class="dropdown-content">
          <router-link 
            :to="{
              name: '3dScroll' , 
              params: { lang: language } 
            }" 
            class="navbar-item">
            3D Scroll
          </router-link>
          <hr class="dropdown-divider">
          <router-link 
            :to="{
              name: 'RainOfDonuts' , 
              params: { lang: language } 
            }" 
            class="navbar-item">
            Rain Of Donuts
          </router-link>
          <router-link 
            :to="{
              name: 'AddObject' , 
              params: { lang: language } 
            }" 
            class="navbar-item">
            Add Object
          </router-link>
          <router-link 
            :to="{
              name: 'MovingCharacter' , 
              params: { lang: language } 
            }" 
            class="navbar-item">
            Move Character
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'drop-down',
  props: {
    language: String,
  },
  mounted() {
    this.$refs.dropDownEl.onmouseenter = this.openDropDown
    this.$refs.dropDownEl.onmouseleave = this.closeDropDown

    Array.from(document.getElementsByClassName('navbar-item')).forEach(
      el => {
        el.onclick = e => e.target.classList.toggle('is-active')
      }
    )
    
  },
  methods: {
    openDropDown() {
      this.$refs.dropDownEl.classList.add('is-active')
      if (this.$route.name == '3dScroll') {
        document.querySelector('main').style.zIndex = '9'
      }
    },
    closeDropDown() {
      if (this.$route.name == '3dScroll') {
        document.querySelector('main').style.zIndex = '99'
      }
      this.$refs.dropDownEl.classList.remove('is-active')
    },
  }
}
</script>

<style scoped>

</style>